import mixpanel from "mixpanel-browser";
import { getIsOnpremise, isLoggedInUser } from "..";
import getEnv from "../getEnv";
import isMobile from "../isMobile";
import { MIXPANEL_OTHER_EVENTS } from "../mixpanelEvents";
export var trackPageExit = function trackPageExit(page) {
  var isOnPremise = getIsOnpremise();
  var MIXPANEL_TOKEN = getEnv("NEXT_PUBLIC_MIXPANEL_TOKEN");
  if (isOnPremise || !MIXPANEL_TOKEN || !isLoggedInUser()) {
    return;
  }
  mixpanel.track(MIXPANEL_OTHER_EVENTS.PAGE_EXIT, {
    page: page,
    deviceType: isMobile() ? "mobile" : "desktop"
  }, {
    send_immediately: true
  });
};